import actions from './actions'

const defaultMedia = {
    hashtag: [],
    type: 0,
    url: '',
    name: '',
    media_id: 0,
}

const initState = {
    medias: [],
    currentMedia: {},
    textSearch: "",
    lastTextSearch: "",

    total: 0,
    pageSize: 24,
    pageIndex: 1,

    // cache
    file: [],
    _status: 0,

    // modal
    modalMediaInfoState: false,
    modalConfirmDeleteMedia: false,
    currentListMedia: [],
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.GET_LIST_MEDIA_QUERY_BY_ID_DONE:
            return {
                ...state,
                ...{
                    currentListMedia: action.payload.data,
                },
            }
        case actions.type.LOAD_LIST_MEDIA:
            return state

        case actions.type.LOAD_LIST_MEDIA_SUCCESS:
            return {
                ...state,
                ...{
                    medias: action.payload.medias,
                    file: [],
                },
            }

        case actions.type.SET_DEFAULT_CURRENT_MEDIA:
            return {
                ...state,
                ...{
                    file: [],
                    currentMedia: defaultMedia,
                },
            }

        case actions.type.UPDATE_CURRENT_MEDIA:
            return {
                ...state,
                ...{
                    currentMedia: {
                        ...state.currentMedia,
                        ...action.payload.media,
                    },
                },
            }

        case actions.type.SAVE_CURRENT_MEDIA:
            return state

        case actions.type.DELETE_MEDIA:
            return state

        case actions.type.UPDATE_STATE:
            return {
                ...state,
                ...action.payload.state,
            }

        case actions.type.UPDATE_FILE:
            return {
                ...state,
                ...{
                    file: state.file.concat(action.payload.file),
                },
            }

        case actions.type.CHANGE_PAGE_SIZE:
            return {
                ...state,
                ...{
                    pageSize: action.payload.pageSize,
                    pageIndex: 1,
                },
            }

        case actions.type.CHANGE_CURRENT_PAGE:
            return {
                ...state,
                ...{
                    pageIndex: action.payload.pageIndex,
                },
            }

        case actions.type.SHOW_MODAL_CURRENT_MEDIA_INFO:
            return {
                ...state,
                ...{
                    modalMediaInfoState: true,
                },
            }

        case actions.type.DISMISS_MODAL_CURRENT_MEDIA_INFO:
            return {
                ...state,
                ...{
                    modalMediaInfoState: false,
                },
            }

        case actions.type.SHOW_MODAL_CONFIRM_DELETE_MEDIA:
            return {
                ...state,
                ...{
                    modalConfirmDeleteMedia: true,
                },
            }

        case actions.type.DISMISS_MODAL_CONFIRM_DELETE_MEDIA:
            return {
                ...state,
                ...{
                    modalConfirmDeleteMedia: false,
                },
            }

        case actions.type.UPDATE_TEXT_SEARCH:
            return {
                ...state,
                ...{
                    textSearch: action.payload.textSearch
                }
            }

        case actions.type.SEARCH_MEDIA:
            return {
                ...state,
                ...{
                    lastTextSearch: state.textSearch
                }
            }

        default:
            return state
    }
}

export default reducer
